import { AppstoreOutlined } from '@ant-design/icons';
import { Flex, Row } from "antd";
import { ReactNode, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { centeredPadding, titleStyle } from '../../constants/style';
import Title from 'antd/es/typography/Title';
import ApiContext from '../../api/context';

const headerStyle = {
  backgroundColor: "rgb(29, 29, 29)",
  color: "white",
  fontFamily: 'Georgia',
  fontSize: "2em",
  padding: `10px ${centeredPadding(400)}`,
  width: "100%"
};

const contentStyle = {
  fontFamily: "Roboto",
  fontSize: "1em",
  padding: `20px ${centeredPadding(400)}`,
  paddingBottom: 0
};

const listStyle = {
  margin: 0,
  padding: 0
};

const listItemStyle = {
  margin: "0 0 0 20px",
  padding: 0,
  display: 'inline',
  fontSize: '.6em'
};

export type Props = {
  children?: ReactNode,
  title?: string
};

type MenuProps = {
  location: String,
  onLogin: () => void,
  onMenu: () => void
}

function MenuButton(p: MenuProps) {
  if (p.location === "/") {
    return (
      <a onClick={() => {
        p.onLogin();
      }}>
        Log Out
      </a>
    );
  }

  return (
    <a onClick={() => { p.onMenu(); }}>
      <AppstoreOutlined />
    </a>
  );
}

export default function (p: Props) {
  const [tokenChecked, setTokenChecked] = useState(false);
  const { api, setToken } = useContext(ApiContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hasApiToken = api?.hasToken();
    if (!hasApiToken) {
      navigate("/login");
      return;
    }

    setTokenChecked(true);
  }, [api, navigate, setTokenChecked]);

  if (!tokenChecked) {
    return <></>;
  }

  return (
    <div>
      <Flex>
        <Row style={headerStyle} justify="space-between" align="middle">
          <span>Tiller</span>
          <div>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <MenuButton
                  location={location.pathname}
                  onLogin={() => {
                    localStorage.removeItem("token");
                    setToken(undefined);
                    navigate("/login");
                  }}
                  onMenu={() => navigate("/")} />
              </li>
            </ul>
          </div>
        </Row>
      </Flex>
      <div style={contentStyle}>
        {
          !p.title ? undefined :
            <Title style={titleStyle} level={3}>{p.title}</Title>
        }
        {p.children}
      </div>
      <div className="footer">
        <Row justify="center" align="middle">
          <a style={{ margin: "0 5px" }} onClick={() => navigate("/about")}>About</a>
          <a style={{ margin: "0 5px" }} onClick={() => navigate("/privacy")}>Privacy</a>
        </Row>
      </div>
    </div>
  )
}